<div>
    <div style="padding-bottom: 5px;">Payments:</div>
    <div class="payment" *ngFor="let payment of payments" style="padding: 5px 0px;">
        <span class="link" (click)="selectPayment(payment)" *ngIf="payment.order?.data?.donation">{{payment.order.data.donation.currency}} {{payment.order.data.donation.amount | currency}} - {{payment.order.data.donation.intervalStr}}</span>
        <span *ngIf="!payment.order?.data?.donation">No order donation for this payment.</span>
    </div>
</div>
